/**
 * One-time migration utility to move trips from localStorage to database
 *
 * To run this migration:
 * 1. Open browser console on any page where you're logged in
 * 2. Run: window.runTripMigration()
 * 3. Check console for migration results
 */

import SocialServiceDB from '../services/socialServiceDB';

async function runTripMigration() {
  console.log('🚀 Starting trip migration from localStorage to database...');
  console.log('⏳ This may take a moment...');

  try {
    const result = await SocialServiceDB.migrateTripsToDatabase();

    if (result.success) {
      console.log('✅ Migration completed successfully!');
      console.log(`📊 Results:
        - Total trips: ${result.total}
        - Migrated: ${result.migrated}
        - Skipped: ${result.skipped}
        - Errors: ${result.errors.length}
      `);

      if (result.errors.length > 0) {
        console.warn('⚠️ Some trips encountered errors:');
        result.errors.forEach(err => {
          console.warn(`  - ${err.tripName}: ${err.error}`);
        });
      }

      alert(`Migration complete! ${result.migrated}/${result.total} trips migrated successfully.`);

      // Suggest refreshing the page
      if (result.migrated > 0) {
        const shouldRefresh = window.confirm('Migration complete! Refresh the page to see your trips in the social feed?');
        if (shouldRefresh) {
          window.location.reload();
        }
      }
    } else {
      console.error('❌ Migration failed:', result.error);
      alert(`Migration failed: ${result.error}`);
    }

    return result;
  } catch (error) {
    console.error('❌ Migration error:', error);
    alert(`Migration error: ${error.message}`);
    throw error;
  }
}

// Expose to window for easy console access
if (typeof window !== 'undefined') {
  window.runTripMigration = runTripMigration;
  console.log('💡 Trip migration utility loaded! Run window.runTripMigration() to migrate trips.');
}

export default runTripMigration;
